import styled from 'styled-components';

import {
  paradigmLightBlue,
  pickledBluewood,
  portage15,
} from '@paradigm/design-system/src/colors';

// Matches `.settings-modal .settings-link` text in
// _settings-modal.scss — kept in sync as a single literal here so the
// billing sub-view doesn't drift from the rest of the modal.
export const settingsTextPrimary = '#f5f5f5';

export const Card = styled.section`
  padding: 14px 16px;
  background-color: ${pickledBluewood};
  border: 1px solid ${portage15};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${paradigmLightBlue};
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

export const Hint = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: ${settingsTextPrimary};
  opacity: 0.7;
`;
